// extracted by mini-css-extract-plugin
export default {"matchContainer":"matchdisplay_matchContainer__twm4R"};